import utils from '../libs/utils';
import axios from './axios';

const baseUrl = 'v1/erp-business-web';

export default {
  axios,
  recallPlanList(params) { // 药品召回计划列表
    return axios.post(`${baseUrl}/sale/recall/plan/list`, utils.exchangeParams(params));
  },

  recallPlanSubmit(params) { // 提交召回计划
    return axios.post(`${baseUrl}/sale/recall/plan/submit`, utils.exchangeParams(params));
  },

  recallPlanCreate(params) { // 创建(保存)提交计划
    return axios.post(`${baseUrl}/sale/recall/plan/create`, utils.exchangeParams(params));
  },

  recallPlanUpdate(params) { // 更新召回计划(草稿状态)
    return axios.post(`${baseUrl}/sale/recall/plan/update`, utils.exchangeParams(params));
  },

  recallPlanRecord(params) { // 药品召回录入(审批通过状态)
    return axios.post(`${baseUrl}/sale/recall/plan/infos/save`, utils.exchangeParams(params));
  },

  recallPlanGoodsList(params) { // 选择召回商品列表
    return axios.post(`${baseUrl}/sale/recall/plan/info/list`, utils.exchangeParams(params));
  },

  recallPlanInfo(params) { // 召回计划详情
    return axios.post(`${baseUrl}/sale/recall/plan/detail`, utils.exchangeParams(params));
  },

  recallWorkflow(params) { // 审批中，查看召回计划审批流程
    return axios.post(`${baseUrl}/sale/recall/plan/work/flow`, utils.exchangeParams(params));
  },

  recallOperateLog(params) { // 操作日志
    return axios.post(`${baseUrl}/sale/recall/plan/history/list`, utils.exchangeParams(params));
  },

  recallPlanDone(params) { // 录入完成
    return axios.post(`${baseUrl}/sale/recall/plan/done`, utils.exchangeParams(params));
  },

  // goodsList(params) {
  //   return axios.get(`${baseUrl}/saleReport/listDetailReport?${utils.exchangeParams(params)}`);
  // },
  listRefundOrderDetail(params) { // 销售退货商品
    return axios.get(`${baseUrl}/saleRefund/listRefundOrderDetail?${utils.exchangeParams(params)}`);
  },
  recallPlanOperationList(params) {
    return axios.post(`${baseUrl}/sale/recall/plan/operate/list`, utils.exchangeParams(params));
  },

  returnList(params) {
    return axios.get(`${baseUrl}/saleRefund/list?${utils.exchangeParams(params)}`);
  },

  returnInfo(params) {
    return axios.get(`${baseUrl}/saleRefund/info?${utils.exchangeParams(params)}`);
  },

  addReturn(params) {
    return axios.post(`${baseUrl}/saleRefund/addAndSubmit`, params);
  },

  updateReturn(params) {
    return axios.post(`${baseUrl}/saleRefund/submit`, params);
  },

  deleteReturn(params) {
    return axios.post(`${baseUrl}/saleRefund/delete`, utils.exchangeParams(params));
  },

  saleRefundPrint(params) {
    return axios.get(`${baseUrl}/saleRefund/print?${utils.exchangeParams(params)}`);
  },

  // 导出Excel
  downloadExcel(params) {
    return axios.post(`${baseUrl}/saleRefund/download`, utils.exchangeParams(params));
  },
  // 获取收款方式
  getPayMethod(params) {
    return axios.get(`${baseUrl}/saleRefund/listRefundOrderProceeds?${utils.exchangeParams(params)}`);
  },
};
